import React, { useEffect } from 'react';

import styles from './GameActivity.module.less';
import GameLink from '../../components/GameLink/GameLink';
import { useInView } from 'react-intersection-observer';

export default ({ data: dataSource, logInfo = {} }) => {
  const { dataList } = dataSource || {};
  const data = (dataList && dataList[0]) || {};
  const { tag: source } = logInfo;

  const [ref, inView] = useInView({
    threshold: 1,
  });
  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: dataList && dataList[0] && dataList[0].pageCardContentId,
        pageCardTitle: dataSource && dataSource.title,
        rankCode: dataList && dataList[0] && dataList[0].code,
        cardType: dataSource && dataSource.cardType,
        org: dataList && dataList[0] && dataList[0].org,
      });
    }
  }, [inView]);

  if (!['1', '2', '3', '5', '10', '11', '12'].includes(data.targetType)) {
    return null;
  }

  return (
    <div ref={ref}>
      <GameLink
        className={styles.Activity}
        info={data}
        source={source}
        logInfo={{
          category: 'C',
          action: source,
          params: {
            id: data.activityId || '',
            source,
          },
          bizInfo: data.bizInfo,
        }}
      >
        <div className={'activity_cont'}>
          <img className={'banner_item_bg'} src={data.contentImgBig || data.contentImg} />
          <div>
            <h1 title={data.contentTitle}>{data.contentTitle}</h1>
            <p>{data.contentDesc}</p>
            <h2>
              活动时间：
              <br />
              {data.activityStartTime.replace(/\s*\d+:\d+:\d+/g, '').replace(/-/g, '.')} -{' '}
              {data.activityEndTime.replace(/\s*\d+:\d+:\d+/g, '').replace(/-/g, '.')}
            </h2>
            {data.activityType === '1' ? (
              <span className="waiting">待开始</span>
            ) : data.activityType === '2' ? (
              <span className="active">进行中</span>
            ) : (
              <span className="closed">已结束</span>
            )}
          </div>
        </div>
      </GameLink>
    </div>
  );
};
